const forbiddenWords = ["admin", "test", "null", "undefined"];

export const validateTextField = (value, t, options = {}) => {
	const {
		fieldName = t("field"),
		minLength = 3,
		maxLength = 24,
		forbiddenChars = "@#$%^&*",
	} = options;

	if (!value || value.trim().length < minLength) {
		return t("fieldMustBeAtLeastXChars", {
			field: fieldName,
			count: minLength,
		});
	}

	if (value.length > maxLength) {
		return t("fieldMustBeAtMostXChars", {
			field: fieldName,
			count: maxLength,
		});
	}

	const forbiddenPattern = new RegExp(
		`[${forbiddenChars.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}]`
	);
	if (forbiddenPattern.test(value)) {
		return t("fieldContainsForbiddenChars", { field: fieldName });
	}

	const lower = value.toLowerCase();
	if (forbiddenWords.some((word) => lower.includes(word))) {
		return t("fieldContainsForbiddenWord", { field: fieldName });
	}

	return "";
};

export const validateEmail = (value, t) => {
	if (!value) return t("pleaseEnterValidEmail");

	if (value.length < 13) {
		return t("emailMustBeAtLeast13Chars");
	}

	if (value.length > 254) {
		return t("emailMustBeAtMost254Chars");
	}

	const emailRegex =
		/^(?![_.-])([a-zA-Z][a-zA-Z0-9._+-]{7,63})@(?=.{3,128}$)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

	if (!emailRegex.test(value)) {
		return t("pleaseEnterValidEmail");
	}

	if (value.includes("..")) {
		return t("emailCannotContainDoubleDots");
	}

	return "";
};
